@import 'apps/webcomponents/src/assets/common.scss';

.details-panel--container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .details-panel--header {
    padding: calc(var(--spacer) * 4) 0 var(--spacer) 0;

    gz-title {
      color: var(--black-layout-700-primary);
    }
  }

  .details-panel--content {
    flex: 1 1 0%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;

    .content-detection {
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
    }

    .content-detection,
    .content-message {
      font-size: var(--body-size);

      .content-detection--title,
      .content-message--title {
        text-transform: uppercase;
        font-weight: 600;
        font-size: var(--body-size-small);
        color: var(--chart-300-icon-buttons);
      }

      .content--label {
        width: 144px;
        color: var(--main-titles-inputs-600);
        font-family: var(--font-family-secondary);
        font-size: var(--body-size-large);
      }

      .content--value {
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: var(--main-titles-inputs-600);
        font-family: var(--font-family-secondary);
        font-size: var(--body-size-medium);
      }
    }
  }
}
